import { render, staticRenderFns } from "./Mailmaga.vue?vue&type=template&id=c54bc820&scoped=true&"
import script from "./Mailmaga.vue?vue&type=script&lang=js&"
export * from "./Mailmaga.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/formats.scss?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/scss/pages/pages.scss?vue&type=style&index=1&lang=scss&"
import style2 from "./Mailmaga.vue?vue&type=style&index=2&id=c54bc820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54bc820",
  null
  
)

export default component.exports